export class DataService {
    getTestData = async () => {
        const response = await fetch('./datastore/testdata.json');
        // const response = await fetch('./datastore/code.json');
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        const data = await response.json();
        return data;
    }

    getAirportsData = async () => {
        try {
            const response = await fetch('./datastore/airports.json');
            if (!response.ok) {
                throw new Error('Failed to fetch airports data');
            }
            const data = await response.json();

            // Ensure the data is an array
            if (!Array.isArray(data)) {
                throw new Error('Invalid data format: expected an array of airports');
            }
            return data;
        } catch (error) {
            console.log('Error fetching airport data:', error);
            return [];
        }
    };

    getRouteData = async (sourceCode, destinationCode, layoverCodes, filterInfo) => {
        const response = await fetch('./datastore/routes.json');
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        var data = await response.json();
        if (layoverCodes != null && layoverCodes.length > 0) {
            data = data.filter(x => x.OriginLocation == sourceCode && x.DestinationLocation == destinationCode).map(
                y => {
                    console.log(y.FlightSegment.map(f => f.LayoverAirport).equals(layoverCodes));
                    if (y.FlightSegment.map(f => f.LayoverAirport).equals(layoverCodes))
                        return y;
                })
            data = data.filter(x => x != null && x != undefined);
        }
        if (filterInfo != null && filterInfo.stopscount != null && filterInfo.stopscount.length > 0) {
            filterInfo.stopscount.forEach(x => {
                data = data.filter(y =>
                    (x == '0' && (y.FlightSegment == null || y.FlightSegment.length == 0))
                    || (x == '1' && y.FlightSegment.length == 1)
                    || (x == '2' && y.FlightSegment.length == 2)
                    || (x == '2+' && y.FlightSegment.length > 2))
            })
        }
        return data;
    }

    getRouteDataById = async (id) => {
        const response = await fetch('./datastore/routes.json');
        if (!response.ok) {
            throw new Error('Failed to fetch data');
        }
        var data = await response.json();
        if (id != null && id > 0) {
            data = data.filter(x => x.id == id);
            return data.length > 0 ? data[0] : {};
        }
        return {};
    }
}

